import React from 'react'

const FormSuccess = (props) => {
    const hideSuccess = (event) => {
        event.preventDefault()
        props.hideSuccess()
    }

    return (
        <div className='form-success'>
            {props.icon === false ? '' : <img src='/images/icon-tick.svg' alt='' />}
            {typeof props.message === 'object' ? props.message : <span dangerouslySetInnerHTML={{ __html: props.message }} />}
            {props.hideSuccess ? <a href='#' className='close-btn' onClick={hideSuccess}><img src='/images/icon-close.svg' alt='Close' /></a> : ''}
        </div>
    )
}

export default FormSuccess



// WEBPACK FOOTER //
// ./resources/js/components/FormSuccess.js